import { BellOff, PhoneCall } from 'lucide-react';

import { Switch } from '@apps/web/components/ui/switch';

export function BrowserRingAvailabilityControl({
    isAvailable,
    isBrowserRingReady,
    isPublishedAvailable,
    onAvailableChange,
}: {
    readonly isAvailable: boolean;
    readonly isBrowserRingReady: boolean;
    readonly isPublishedAvailable: boolean;
    readonly onAvailableChange: (available: boolean) => void;
}) {
    const status = !isAvailable
        ? 'Calls will not ring this browser.'
        : isPublishedAvailable
          ? 'Ready for incoming calls.'
          : isBrowserRingReady
            ? 'Syncing call availability…'
            : 'Connecting browser phone…';

    return (
        <section
            aria-label="Incoming call availability"
            className="bg-background fixed right-4 bottom-4 z-[100] w-80 rounded-xl border p-4 shadow-xl"
            data-browser-ring-ready={isBrowserRingReady}
        >
            <div className="flex items-center gap-3">
                <div
                    className={
                        isPublishedAvailable
                            ? 'flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-100 dark:bg-green-950/50'
                            : 'bg-muted flex h-10 w-10 shrink-0 items-center justify-center rounded-full'
                    }
                >
                    {isAvailable ? (
                        <PhoneCall
                            className={
                                isPublishedAvailable
                                    ? 'h-5 w-5 text-green-700 dark:text-green-300'
                                    : 'text-muted-foreground h-5 w-5'
                            }
                        />
                    ) : (
                        <BellOff className="text-muted-foreground h-5 w-5" />
                    )}
                </div>
                <div className="min-w-0 flex-1">
                    <label
                        className="text-foreground text-sm font-semibold"
                        htmlFor="browser-ring-availability"
                    >
                        Available for calls
                    </label>
                    <p
                        aria-live="polite"
                        className="text-muted-foreground text-xs"
                    >
                        {status}
                    </p>
                </div>
                <Switch
                    aria-label="Available for incoming browser calls"
                    checked={isAvailable}
                    id="browser-ring-availability"
                    onCheckedChange={onAvailableChange}
                />
            </div>
        </section>
    );
}
